var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68933 9.77342C9.98223 10.0663 10.4571 10.0663 10.75 9.77342C11.0429 9.48053 11.0429 9.00566 10.75 8.71276L7.0377 5.00047L10.75 1.28819C11.0429 0.995293 11.0429 0.52042 10.75 0.227527C10.4571 -0.0653667 9.98222 -0.0653667 9.68933 0.227527L5.97704 3.93981L2.26471 0.227483C1.97182 -0.065411 1.49695 -0.0654107 1.20405 0.227483C0.911161 0.520376 0.91116 0.995249 1.20405 1.28814L4.91638 5.00047L1.20405 8.71281C0.911151 9.0057 0.911152 9.48057 1.20405 9.77347C1.49694 10.0664 1.97181 10.0664 2.26471 9.77347L5.97704 6.06113L9.68933 9.77342Z",
    fill: "#DC2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.730c72e7.svg";
export { ForwardRef as ReactComponent };